/**
 * Ponte para exibir o modal de alerta a partir de código que não tem acesso
 * ao React Context (ex.: utilitários como fileDownload).
 * O ModalProvider registra showAlert ao montar e remove ao desmontar.
 */

export interface BridgeAlertOptions {
  title: string;
  message: string;
  variant?: 'success' | 'danger' | 'warning' | 'info';
  details?: string;
}

type AlertHandler = (options: BridgeAlertOptions) => void;

let globalAlertHandler: AlertHandler | null = null;

export function setGlobalAlertHandler(handler: AlertHandler | null): void {
  globalAlertHandler = handler;
}

export function getGlobalAlertHandler(): AlertHandler | null {
  return globalAlertHandler;
}
